module.exports = __webpack_public_path__ + "img/101-667439.png";